export default __webpack_public_path__ + "static/media/spoon.b5681c86.svg";